import { MoneyInput, WeightInput } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const loadReconciliationBatchUpdateAtom = createMutationAtomFactory(
  'customerPortal.loadReconciliationBatchUpdate',
  (params: {
    loadId: string;
    receivedLineItems: {
      id?: string;
      loadLineItemId: string;
      grossWeight: WeightInput;
      tareWeight: WeightInput;
      materialType: string;
      unitPrice: MoneyInput;
      pricingUnit: string;
    }[];
    deductions: {
      id?: string;
      deductionTypeId: string;
      priceQuantity?: MoneyInput;
      weightQuantity?: WeightInput | null;
      receivedLineItemId?: string;
    }[];
  }) => ({
    tradeReconciliationBatchUpdate: {
      __args: {
        loadId: params.loadId,
        receivedLineItems: params.receivedLineItems,
        deductions: params.deductions,
      },
      id: true,
    },
  }),
);
